import { Component, OnInit, Input } from "@angular/core";
import { last, findIndex } from "lodash";

@Component({
  selector: "calendar-tile",
  templateUrl: "./calendar-tile.component.html",
  styleUrls: ["./calendar-tile.component.scss"],
})
export class CalendarTileComponent implements OnInit {
  @Input() data;
  @Input() suffix;

  selectedMonth: string;
  calendar;
  calendarIndex: number;

  constructor() {}

  ngOnInit() {
    this.calendar = last(this.data.chartData);
    this.selectedMonth = this.calendar.name;
    this.calendarIndex = this.data.chartData.length - 1;
  }

  min: number = 1;
  max: number = 14;

  days: Array<DayObj> = [
    { x: 0, name: "Mon" },
    { x: 1, name: "Tues" },
    { x: 2, name: "Wed" },
    { x: 3, name: "Thurs" },
    { x: 4, name: "Fri" },
  ];

  weeks: Array<WeekObj> = [
    { y: 0, name: "Week 1" },
    { y: 1, name: "Week 2" },
    { y: 2, name: "Week 3" },
    { y: 3, name: "Week 4" },
    { y: 4, name: "Week 5" },
  ];

  monthSelected(month) {
    this.selectedMonth = month;
    this.calendarIndex = findIndex(this.data.chartData, ["name", month])
    this.calendar = this.data.chartData[this.calendarIndex];
  }

  monthIndexSelected(monthIndex) {
    this.calendarIndex = Math.min(Math.max(monthIndex, 0), this.data.chartData.length - 1);
    this.calendar = this.data.chartData[this.calendarIndex];
    this.selectedMonth = this.calendar.name;
  }
}

export interface DayObj {
  name: string;
  x: number;
}

export interface WeekObj {
  name: string;
  y: number;
}
